import { CurrencyFormatted, CardHeader, CardTitle, Loading } from '@ui/components';
import { PercentageBar } from '@pages/cost-centers/components';
import { LabeledText } from '@pages/cost-centers/components';
import { ComponentPropsWithoutRef, FC } from 'react';
import { CardContent, Card } from '@ui/components';
import { HasPermission } from '@shared/components';
import { NavPayment } from '@ui/components/icons';
import { useTranslation } from 'react-i18next';
import { Button } from '@ui/components';
import { cn } from '@ui/utils';

import { EditCostCenterDrawer } from '../../cost-center-form-drawer/edit-cost-center-drawer/edit-cost-center-drawer';
import { useCostCenterExpensesSummary } from './use-cost-center-expanses-summary';

export const CostCenterExpensesSummary: FC<ComponentPropsWithoutRef<typeof Card>> = ({
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const { data, isLoading, costCenterId } = useCostCenterExpensesSummary();

  return (
    <Card className={cn('flex flex-col', className)} {...props}>
      <CardHeader className="justify-between">
        <div className="flex items-center gap-2">
          <NavPayment className="w-4.5 h-4.5 text-weak" />
          <CardTitle>{t('COST_CENTER.EXPENSES_SUMMARY.TITLE')}</CardTitle>
        </div>
        <HasPermission
          permissionFeature="COST_CENTER_EDIT_COST_CENTER_ADDRESS"
          permissionType="READ"
        >
          <EditCostCenterDrawer id={costCenterId}>
            <Button disabled={isLoading} variant="link">
              {t('COST_CENTER.DETAILS')}
            </Button>
          </EditCostCenterDrawer>
        </HasPermission>
      </CardHeader>
      <CardContent className="flex-1 grid grid-cols-2 gap-4 grid-rows-[1fr_auto] pb-6">
        <Loading className="col-span-2 row-span-2" isLoading={isLoading}>
          <LabeledText
            label={t('COST_CENTER.EXPENSES_SUMMARY.EXPENSES_THIS_MONTH')}
            isLoading={isLoading}
          >
            <CurrencyFormatted currency={data?.currency} value={data?.amount || 0} />
          </LabeledText>

          <PercentageBar
            value={data?.previousMonthComparisonPercentage || -100}
            className="w-full col-span-2"
          />
        </Loading>
      </CardContent>
    </Card>
  );
};
